(function () {
  'use strict';
  var SEL = '[data-tc-lang]';
  function parts(root) {
    return { btn: root.querySelector('[data-tc-lang-toggle]'), menu: root.querySelector('.tc-lang__menu') };
  }
  function close(root, refocus) {
    var p = parts(root);
    if (!p.btn || !p.menu || p.menu.hidden) return;
    p.menu.hidden = true;
    p.btn.setAttribute('aria-expanded', 'false');
    root.classList.remove('is-open');
    if (refocus) p.btn.focus();
  }
  function open(root) {
    var p = parts(root);
    if (!p.btn || !p.menu) return;
    document.querySelectorAll(SEL + '.is-open').forEach(function (o) { if (o !== root) close(o); });
    p.menu.hidden = false;
    p.btn.setAttribute('aria-expanded', 'true');
    root.classList.add('is-open');
    var first = p.menu.querySelector('button:not([disabled]):not([aria-current]), a[href]') || p.menu.querySelector('button:not([disabled])');
    if (first) first.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-tc-lang-toggle]');
    if (t) {
      var root = t.closest(SEL);
      if (root.classList.contains('is-open')) close(root, true); else open(root);
      return;
    }
    var cur = e.target.closest && e.target.closest('[aria-current][data-tc-lang-opt]');
    if (cur) { close(cur.closest(SEL), true); return; }
    document.querySelectorAll(SEL + '.is-open').forEach(function (o) { if (!o.contains(e.target)) close(o); });
  });
  document.addEventListener('keydown', function (e) {
    var root = e.target.closest && e.target.closest(SEL);
    if (e.key === 'Escape') {
      var openRoot = (root && root.classList.contains('is-open')) ? root : document.querySelector(SEL + '.is-open');
      if (openRoot) { e.preventDefault(); close(openRoot, true); }
      return;
    }
    if (!root || !root.classList.contains('is-open')) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      var items = Array.prototype.slice.call(root.querySelectorAll('.tc-lang__menu button:not([disabled]), .tc-lang__menu a[href]'));
      if (!items.length) return;
      var i = items.indexOf(document.activeElement);
      i = e.key === 'ArrowDown' ? (i + 1) % items.length : (i <= 0 ? items.length - 1 : i - 1);
      e.preventDefault(); items[i].focus();
    }
  });
  document.addEventListener('focusin', function (e) {
    document.querySelectorAll(SEL + '.is-open').forEach(function (o) { if (!o.contains(e.target)) close(o); });
  });
  // Preview links: keep the current query string (minus preview_theme_id, re-added when in preview).
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-tc-lang-pv]');
    if (!a) return;
    var p = new URLSearchParams(window.location.search);
    p.delete('preview_theme_id');
    var th = a.getAttribute('data-tc-lang-theme');
    var q = p.toString();
    var base = a.getAttribute('href').split('?')[0];
    a.setAttribute('href', base + (q || th ? '?' + q + (th ? (q ? '&' : '') + 'preview_theme_id=' + encodeURIComponent(th) : '') : ''));
  }, true);
})();
